import React from 'react'
export const ContractStatus = ({ data, has_driver }) => {
  const { canceled, in_progress, lending_car, waiting_assign_car, assigned_car, finished, lending_driver, lending_car_and_driver } = data
  let STATUS_DATA = [
    {
      id: 1,
      name: 'Đang chờ điều xe',
      count: waiting_assign_car ? waiting_assign_car : 0,
      color: '#fbe350'
    },
    {
      id: 2,
      name: 'Đã điều xe',
      count: assigned_car ? assigned_car : 0,
      color: '#e68927'
    },
    {
      id: 3,
      name: 'Đang diễn ra',
      count: in_progress ? in_progress : 0,
      color: '#45acf9'
    },
    {
      id: 4,
      name: 'Đã hoàn thành',
      count: finished ? finished : 0,
      color: '#139123'
    },
    {
      id: 5,
      name: 'Đã huỷ',
      count: canceled ? canceled : 0,
      color: '#d11338'
    }
  ]

  if (has_driver) {
    const HAS_DRIVER_STATUS = [{
      id: 6,
      name: 'Đang cho mượn xe',
      count: lending_car ? lending_car : 0,
      color: '#b330dc'
    },
    {
      id: 7,
      name: 'Đang cho mượn tài',
      count: lending_driver ? lending_driver : 0,
      color: '#32dc8e'
    },
    {
      id: 8,
      name: 'Đang cho mượn xe và tài',
      count: lending_car_and_driver ? lending_car_and_driver : 0,
      color: '#E60EBB'
    }];
    STATUS_DATA = STATUS_DATA.concat(HAS_DRIVER_STATUS);
  }
  return (
    <div className="contract-status">
      {STATUS_DATA.map(value => {
        return <div className="item" key={value.id}>
          <span style={{ background: value.color }} className="circle" />
          {value.name}: {value.count}
        </div>
      })}
    </div>
  );
}
